import React from 'react'
import logo from '../../assets/images/bonimoo_logo.png'
import logo2 from '../../assets/images/carmel_logo.png'

export default () => {
    return (
        <div className="partners white center">
            <div className="wrap">
                <h2 className="wow fadeIn">Our partners</h2>
                <div className='partners-images-container'>
                    {
                        [1, 2, 3, 4, 5].map((icon, index) => {
                            return (
                                <div className="one-fifth wow fadeIn" key={index}>
                                    <a href="#">
                                        <img src={index % 2 === 0 ? logo : logo2} alt=""/>
                                    </a>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}